import cx from '@vindr/utils/helpers/cx';
import { Row, Select, SelectProps } from 'antd';
import { useState } from 'react';

type TagInputFilter = SelectProps<string[]> & {
  title?: string | boolean;
  width?: number | string;
  wrapperClassName?: string;
  onChange: (val: string[]) => void;
};

const TagInputFilter = ({
  value,
  onChange,
  placeholder,
  title,
  width = 200,
  className,
  wrapperClassName,
  ...props
}: TagInputFilter) => {
  return (
    <div className={wrapperClassName} style={{ width, maxWidth: '100%' }}>
      {title && <Row className="filter-title pb-1 pt-[6px]">{title}</Row>}
      <Select
        mode="tags"
        maxTagCount="responsive"
        size="small"
        value={value}
        className={cx('w-full pl-0', className)}
        placeholder={placeholder}
        onChange={(val) => {
          onChange(val);
        }}
        {...props}
      />
    </div>
  );
};

export default TagInputFilter;
